var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#E9AA00",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2336_16066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5273 31.1272V16.8727C13.5273 16.3127 13.7324 15.8333 14.1426 15.4345C14.5528 15.0357 15.0459 14.8363 15.6219 14.8363H21.9055C22.4815 14.8363 22.9746 15.0357 23.3848 15.4345C23.795 15.8333 24.0001 16.3127 24.0001 16.8727V18.909H32.3783C32.9543 18.909 33.4473 19.1084 33.8575 19.5072C34.2677 19.906 34.4728 20.3854 34.4728 20.9454V31.1272C34.4728 31.6872 34.2677 32.1666 33.8575 32.5654C33.4473 32.9642 32.9543 33.1636 32.3783 33.1636H15.6219C15.0459 33.1636 14.5528 32.9642 14.1426 32.5654C13.7324 32.1666 13.5273 31.6872 13.5273 31.1272ZM15.6219 31.1272H17.7164V29.0908H15.6219V31.1272ZM15.6219 27.0545H17.7164V25.0181H15.6219V27.0545ZM15.6219 22.9818H17.7164V20.9454H15.6219V22.9818ZM15.6219 18.909H17.7164V16.8727H15.6219V18.909ZM19.811 31.1272H21.9055V29.0908H19.811V31.1272ZM19.811 27.0545H21.9055V25.0181H19.811V27.0545ZM19.811 22.9818H21.9055V20.9454H19.811V22.9818ZM19.811 18.909H21.9055V16.8727H19.811V18.909ZM24.0001 31.1272H32.3783V20.9454H24.0001V22.9818H26.0946V25.0181H24.0001V27.0545H26.0946V29.0908H24.0001V31.1272ZM28.1892 25.0181V22.9818H30.2837V25.0181H28.1892ZM28.1892 29.0908V27.0545H30.2837V29.0908H28.1892Z",
    fill: "#B28301"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2336_16066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 28.8,
    fill: "white",
    transform: "translate(9.60156 9.59998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsBox);
export default __webpack_public_path__ + "static/media/accounts_box.e5262042b0623c9fd1217a8653278228.svg";
export { ForwardRef as ReactComponent };